// @flow
import React from 'react';

import Notification from './Notification';
import SoftwareUpdate from "./SoftwareUpdate";
import AuthWrapper from "./AuthWrapper";

class SoftwareUpdatePage extends React.Component {
	render() {
		return (
			<div id="update_content">
				<Notification />
				<AuthWrapper role="adminPassword">
					<SoftwareUpdate />
				</AuthWrapper>
			</div>
		);
	}
}

export default SoftwareUpdatePage;
